import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Icon({iconType, iconName, className}) {
    return (<FontAwesomeIcon icon={[iconType, iconName]} className={className} />)
}

export default Icon